import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { AuthorityLevelDrawer } from './AuthorityLevelDrawer';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/claims-authority/levels/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New level',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <AuthorityLevelDrawer action={['add']} />
        </PageController>
    );
}
